import React from 'react';

const Layout = ({ children }) => {
  return (
    <div className='background d-flex align-items-center'>
      {children}

      <div className='background__top'>
        <div className='background__top-triangle-top'></div>
        <div className='background__top-overlay-square'></div>
        <div className='background__top-triangle-bottom'></div>
      </div>

      <div className='background__bottom'>
        <div className='background__bottom-triangle-top'></div>
        <div className='background__bottom-overlay-square'></div>
        <div className='background__bottom-triangle-bottom'></div>
      </div>
    </div>
  );
};

export default Layout;
